import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import Image7 from '../../assets/images/banner-cloude.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { api } from '../../Constant';
import axios from 'axios';

function NewBanner() {
  const [banners, setBanners] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // fetch banners from API
    axios.post(api + "banner_list")
      .then((res) => {
        const data = res.data;
        if (data.success === "true" && Array.isArray(data.banner)) {
          setBanners(data.banner);
        }
      })
      .catch((error) => console.error("Banner fetch error:", error));

    // detect screen size
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 576); // < sm screens
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <section className="position-relative">
      <Slider {...settings}>
        {banners.map((item) => {
          // ✅ Use mobile image if screen is mobile & mobile image exists
          const bannerImg =
            isMobile && item.mobile_image
              ? item.mobile_image
              : item.banner_image;

          return (
            <div key={item.banner_id}>
              <div className="position-relative">

                {/* ✅ Banner Image */}
                <img
                  src={bannerImg}
                  alt={item.title}
                  className="w-100"
                  style={{
                    zIndex: 0,
                    width: "100%",
                    height: isMobile ? "auto" : "auto", // ✅ Mobile height
                    // objectFit: "cover", // ✅ Prevent stretching
                  }}
                />

                {/* ✅ Text Overlay */}
                <div
                  className="text-content-wrapper"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    paddingLeft: '5%',
                    zIndex: 1,
                  }}
                >
                  <div
                    className="inner-box"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      textAlign: 'left',
                      color: '#745626',
                      gap: '10px',
                    }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                  </div>
                </div>

                {/* ✅ Cloud Overlay */}
                <img
                  src={Image7}
                  alt="Cloud Decoration"
                  className="w-100 position-absolute"
                  style={{ bottom: 10, left: 0, zIndex: 2 }}
                />

              </div>
            </div>
          );
        })}
      </Slider>
    </section>
  );
}

export default NewBanner;
